import { InjectionToken } from '@angular/core'
import { Observable, of } from 'rxjs'

export const PREFERRED_LANGUAGE = new InjectionToken<Observable<string>>('PREFERRED_LANGUAGE', {
  factory: () => of(''),
})
